<template>
  <div>
    <!--首页弹框-->
    <Modal v-if="popupData.is_bottom === 0" class="indexPopup" :value.sync="indexVisible" :closable="false" :scrollable="true" :footer-hide="true"
           :styles="{ top: '150px' }">
      <p class="item-close" @click="close()">
        <img src="/static/img/popup/close_30.png" alt="" />
      </p>
      <div @click="goThat" class="item-img">
        <img :src="popupData.img_url ||
          '../../../static/img/goodsList/goods_default_img.jpg'
          " :onerror="defaultGoodsImg" alt="图片破损" />
      </div>
    </Modal>
    <!--首页弹框-->
    <!--  底部弹窗  -->
    <el-dialog @close="close" title="" v-if="popupData.is_bottom === 1" :visible.sync="indexVisible" :show-close="false"  :close-on-press-escape="false"  custom-class="bottomPopup">
      <div id="bottom" class="bottom">
        <p  class="font16 colorfff" style="display: none;"> 秒后自动关闭 </p>
        <img @click="goThat" :src="popupData.img_url ||
          '../../../static/img/goodsList/goods_default_img.jpg'
          " :onerror="defaultGoodsImg" alt="图片破损"  class="img">
        <img @click="close()" src="https://image.hezongyy.com/pcimage/index/dialog_close.png" alt="" class="close">
      </div>
    </el-dialog>
    <!--  底部弹窗  -->
  </div>
</template>

<script>
import store from "@/vuex/store";
import { mapState, mapGetters } from "vuex";
import { getIndexBulletFrame } from "@/api/index";
import { behaviorUserPageAccess, } from '@/api/apiPot.js'
import { lineLocal } from '@/api/apiPot.js'
export default {
  name: "IndexPopup",
  props: {
    indexVisible: {
      type: Boolean,
      default: false
    },
    popupData: {
      type: Object,
      default: {
        ad_url: '',
        img_url: '',
      }
    }
  },
  data() {
    return {
      defaultGoodsImg:
        'this.src="' +
        require("../../../static/img/goodsList/goods_default_img.jpg") +
        '"',
      imgName: ''
    };
  },
  // mounted() {
  //   this.indexImg();
  // },
  methods: {
    indexImg() {
      /**首页弹出框图片 */
      let _this = this;
      getIndexBulletFrame({ type: 1 })
        .then(res => {
          // lineLocal({ source_type: 7, source_info: '弹窗' })
          this.imgName = res.data.BulletFrame.ad_name
          lineLocal({ source_type: 7, source_info: this.imgName })
          this.popupData = res.data.BulletFrame;
        })
        .catch(err => {
        });
    },
    goThat() {
      // this.$router.push({ path: this.popupData.ad_url });
      behaviorUserPageAccess({ page_index: '列表' })
      window.open(
        this.$router.resolve({ path: this.popupData.ad_url }).href,
        "_blank"
      );
      this.close()
    },
    close() {
      this.$emit("update:indexVisible", false);
      this.$store.dispatch("app/setIndexPopState", 1);

    }
  },
  store
};
</script>

<style lang="less" scoped>
.indexPopup {
  text-align: center;

  .item-close {
    width: 30px;
    height: 30px;
    position: absolute;
    right: -31%;
    top: -25px;
    cursor: pointer;
  }

  .item-img {
    width: 676px;
    height: 600px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.indexPopup /deep/ ivu-modal {}

.indexPopup /deep/ .ivu-modal-content {
  position: relative;
  height: auto;
  background-color: rgb(0 0 0 / 0) !important;
  box-shadow: 0 0 0 rgb(0 0 0 / 0) !important;
}
.bottomPopup{
  #bottom {
    cursor: pointer;
    position: fixed;
    left: 0;
    z-index: 9999;
    width: 100%;
    bottom: -3px;
    text-align: center;
   .img {
      display: inline-block;
      width: 100%;
      height: auto;
      max-height: 500px;
    }
   .close {
      position: absolute;
      top: 0;
      right: 268px;
    }
  }
}
</style>
<style>
.bottomPopup .el-dialog__body {
  padding: 0;
}
.bottomPopup {
  margin: 0;
}
.bottomPopup .el-dialog__header{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/IndexPopup.vue